import { Record } from 'immutable';
import YoutubeVideoDuration from './YoutubeVideoDuration';

const keys: Fields = {
  videoId: '',
  title: '',
  duration: new YoutubeVideoDuration(),
  thumbnail: '',
};

interface Fields {
  videoId: string;
  title: string;
  duration: YoutubeVideoDuration;
  thumbnail: string;
}

export default class YoutubeVideoResourceRecord extends Record<Fields>(keys) {
  getVideoId() {
    return this.videoId;
  }

  getLinkYoutubeUrl() {
    return `https://youtu.be/${this.getVideoId()}`;
  }

  getTitle() {
    return this.title;
  }

  getDefaultThumbnailUrl() {
    return this.thumbnail;
  }

  getVideoDuration() {
    return this.duration;
  }

  setVideoDuration(duration) {
    return this.set('duration', new YoutubeVideoDuration(duration));
  }
}
